import {
  extendPropToFaNameMap,
  Icon,
  IconProps,
  IName,
  propToFaNameMap,
} from '@faxi/web-component-library';
import { FC } from 'react';

export type INameExtended =
  | 'arrow-right'
  | 'badge-check'
  | 'calendar-range'
  | 'calendar-days'
  | 'car-garage'
  | 'car-side'
  | 'car-solid'
  | 'car-wrench'
  | 'circle-info'
  | 'coins-solid'
  | 'coins'
  | 'file-invoice'
  | 'laptop'
  | 'screwdriver-wrench-solid'
  | 'shield-check'
  | 'steering-wheel'
  | 'user-tie-light'
  | 'user-tie'
  | IName;

const customMapNameToFa: Record<INameExtended, string[]> = {
  'arrow-right': ['fa-light', 'fa-arrow-right'],
  'badge-check': ['fa-solid', 'fa-badge-check'],
  'calendar-range': ['fa-solid', 'fa-calendar-range'],
  'calendar-days': ['fa-light ', 'fa-calendar-days'],
  'car-garage': ['fa-light', 'fa-car-garage'],
  'car-side': ['fa-light ', 'fa-car-side'],
  'car-solid': ['fa-solid', 'fa-car'],
  'car-wrench': ['fa-light ', 'fa-car-wrench'],
  'coins-solid': ['fa-solid', 'fa-coins'],
  'coins': ['fa-light', 'fa-coins'],
  'file-invoice': ['fa-light', 'fa-file-invoice'],
  'laptop': ['fa-light', 'fa-laptop'],
  'screwdriver-wrench-solid': ['fa-solid', 'fa-screwdriver-wrench'],
  'shield-check': ['fa-solid', 'fa-shield-check'],
  'steering-wheel': ['fa-light', 'fa-steering-wheel'],
  'user-tie-light': ['fa-light', 'fa-user-tie'],
  'user-tie': ['fa-solid', 'fa-user-tie'],
  ...propToFaNameMap,
};

extendPropToFaNameMap(customMapNameToFa);

export default Icon as FC<IconProps<INameExtended>>;
